module.exports = __webpack_public_path__ + "static/apollo-5e05aa7b68be9229dbd74b9ce53435b9.jpg";